import { createClient } from 'graphqurl'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Accordion from 'react-bootstrap/Accordion'
import Form from 'react-bootstrap/Form'
import Badge from 'react-bootstrap/Badge'
import Image from 'react-bootstrap/Image'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faLocationDot, faBasketShopping } from '@fortawesome/free-solid-svg-icons'

import Poster from '../../components/poster/Poster'
import ViewedPosters from '../../components/poster/ViewedPosters'

// Pagination
import styles from '../../styles/JobPoster.module.scss'

const JobPosters = ({ posters, pagination, posterAggregate, filters, mrtLine, mrtStation, state, citiesObj, occupation, occupationObject }): JSX.Element => {
	const [showModals, setShowModals] = useState({
		mrt: false,
		title: false,
		employmentType: false,
		city: false
	})

	// MRT
	const [mrtInput, setMRTInput] = useState('')
	const [filteredMRTLine, setFilteredMRTLine] = useState(mrtLine)
	const [selectedMRT, setSelectedMRT] = useState(filters.mrt)

	const [cityInput, setCityInput] = useState('')
	const [filteredState, setFilteredState] = useState(state)
	const [selectedCity, setSelectedCity] = useState(filters.city)
	const [selectedState, setSelectedState] = useState<any[]>([])

	// Title
	const [selectedTitles, setSelectedTitles] = useState(filters.occupation.map(ele => parseInt(ele)))

	// Employment Type
	const [selectedEmploymentTypes, setSelectedEmploymentTypes] = useState(filters.jobType)

	// Job Basket Feature
	const [viewedPosters, setViewedPosters] = useState([])
	const [showViewedPosters, setShowViewedPosters] = useState(false)

	const { t } = useTranslation()

	const router = useRouter()
	const locale: string = router.locale as string

	const getCurrentPathWithoutPage = () => {
		const mrt = selectedMRT.length > 0 ? `mrt=${selectedMRT.join(',')}&` : ''
		const city = selectedCity.length > 0 ? `city=${selectedCity.join(',')}&` : ''
		// return `/${locale}/job-posters?${selectedMRT.length > 0 ? `&mrt=${selectedMRT.join(',')}` : ''}${selectedTitles.length > 0 ? `&occupation=${selectedTitles.join(',')}` : ''}${selectedEmploymentTypes.length > 0 ? `&jobType=${selectedEmploymentTypes.join(',')}` : ''}`
		return `/${locale}/job-posters?${locale === 'sg' ? mrt : ''}${locale === 'my' ? city : ''}${selectedTitles.length > 0 ? `&occupation=${selectedTitles.join(',')}` : ''}${selectedEmploymentTypes.length > 0 ? `&jobType=${selectedEmploymentTypes.join(',')}` : ''}`
	}

	const getPaginationLink = page => {
		return `${getCurrentPathWithoutPage()}&page=${page}`
	}

	const onChangeLocation = value => {
		const validated = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
		if (locale === 'sg') {
			setMRTInput(validated)
			setFilteredMRTLine(mrtLine.map(line => {
				return {
					id: line.id,
					name: line.name,
					colour: line.colour,
					MrtStations: line.MrtStations.filter(station => {
						return station.name.toLowerCase().indexOf(validated.toLowerCase()) > -1
					})
				}
			}))
		} else if (locale === 'my') {
			setCityInput(validated)
			setFilteredState(state.map(ele => {
				return {
					id: ele.id,
					name: ele.name,
					Cities: ele.Cities.filter((city) => {
						return city.name.toLowerCase().indexOf(validated.toLowerCase()) > -1
					})
				}
			}))
		}
	}

	const selectMRT = value => {
		const tempSelectedMrt: string[] = Array.from(selectedMRT)
		// const value: string = e.target.value as string
		if (tempSelectedMrt.includes(value)) {
			tempSelectedMrt.splice(tempSelectedMrt.indexOf(value), 1)
		} else {
			tempSelectedMrt.push(value)
		}
		setSelectedMRT(tempSelectedMrt)
	}

	function isAllCityChecked(arr, values) {
		return values.every(value => {
			return arr.map(Number).includes(value)
		})
	}

	const selectCity = (e, stateId) => {
		let tempSelectedCity = Array.from(selectedCity)

		if (typeof e.target !== 'undefined') {
			const value = e.target.value
			if (tempSelectedCity.includes(value)) {
				tempSelectedCity.splice(tempSelectedCity.indexOf(value), 1)
			} else {
				tempSelectedCity.push(value)
			}
			const filteredArr = tempSelectedCity.filter(ele => (ele !== 'others' && ele !== 'multiple'))
			setSelectedCity(filteredArr)
		} else if (e === 'others') {
			if (!selectedCity.includes('others')) setSelectedCity(['others'])
			else setSelectedCity([])
		} else {
			if (!selectedCity.includes('multiple')) setSelectedCity(['multiple'])
			else setSelectedCity([])
		}

		const index = state.findIndex(st => st.id === stateId)
		let cities = state[index].Cities
		cities = cities.map((ct) => ct.id)
		tempSelectedCity = tempSelectedCity.map(Number)

		if(isAllCityChecked(tempSelectedCity, cities)) {
			setSelectedState(selectedCity => [...selectedCity, stateId.toString()])
		} else {
			setSelectedState(selectedState.filter(item => item !== stateId.toString()))
		}
	}

	const selectAllMRT = e => {
		const value = e.target.value
		const currentMrtLine = mrtLine.filter((mrtl) => { return mrtl.id === value })[0]
		const currentMrtStationId = currentMrtLine.MrtStations.map((mrts) => { return mrts.id })
		if (e.target.checked) {
			setSelectedMRT([...new Set([...selectedMRT, ...currentMrtStationId])])
		} else {
			setSelectedMRT(selectedMRT.filter(smrt => {
				return currentMrtStationId.includes(smrt) === false
			}))
		}
	}

	const selectAllCity = e => {
		const value = e.target.value

		const currentState = state.filter((st) => { return st.id === parseInt(value) })[0]
		const currentCityId = currentState.Cities.map((city) => { return city.id.toString() })

		if (e.target.checked === true) {
			const tempArr = [...new Set([...selectedCity, ...currentCityId])]
			const filteredArr = tempArr.filter(ele => ele !== 'others')
			setSelectedCity(filteredArr)
			setSelectedState(selectedCity => [...selectedCity, value])
		} else {
			setSelectedCity(selectedCity.filter((city) => {
				return currentCityId.includes(city) === false || city === 'others'
			}))
			setSelectedState(selectedState.filter(function(e) { return e !== value }))
		}
	}

	const selectTitle = value => {
		const tempSelectedOccupation = Array.from(selectedTitles)
		const parsedValue = parseInt(value)
		if (tempSelectedOccupation.includes(parsedValue)) {
			tempSelectedOccupation.splice(tempSelectedOccupation.indexOf(parsedValue), 1)
		} else {
			tempSelectedOccupation.push(parsedValue)
		}
		setSelectedTitles(tempSelectedOccupation)
	}

	const selectAllTitle = checked => {
		const allOccupationId = occupation.map(ele => ele.id)
		if (checked) {
			setSelectedTitles([...new Set([...selectedTitles, ...allOccupationId])])
		} else {
			setSelectedTitles([])
		}
	}

	const selectEmploymentType = type => {
		const tempJobType = Array.from(selectedEmploymentTypes)
		if (tempJobType.includes(type)) {
			tempJobType.splice(tempJobType.indexOf(type), 1)
		} else {
			tempJobType.push(type)
		}
		setSelectedEmploymentTypes(tempJobType)
	}

	const submitFilter = () => {
		// const path = `/job-posters?${selectedMRT.length > 0 ? `mrt=${selectedMRT.join(',')}&` : ''}`
		window.location.href = getCurrentPathWithoutPage()
	}

	useEffect(() => {
		// window.localStorage.setItem('viewed-posters', JSON.stringify(viewedPosters))
		if (window.localStorage.getItem('viewed-posters') !== null) setViewedPosters(JSON.parse(window.localStorage.getItem('viewed-posters') as string))
		else setViewedPosters([])
	}, [])

	// useEffect(() => {
	// 	window.localStorage.setItem('viewed-posters', JSON.stringify(viewedPosters))
	// }, [viewedPosters])

	return (
		<>
			<Row>
				<Col>
					<h2 className={`${styles.primaryHeader} fw-bold`}>Job Posters</h2>
				</Col>
			</Row>
			<Row>
				<Col className='mt-2' xs={12} sm={4}>
					<Button
						variant='outline-primary'
						className={`fw-bold w-100 ${styles.filter_btn}`}
						onClick={() => {
							setShowModals({
								...showModals,
								mrt: locale === 'sg' ? true : false,
								city: locale === 'my' ? true : false
							})
						}}
					>
						<FontAwesomeIcon icon={faLocationDot} />{` ${locale === 'sg' ? 'MRT' : 'City'}`}
					</Button>
				</Col>
				<Col className='mt-2' xs={12} sm={4}>
					<Button
						variant='outline-primary'
						className={`fw-bold w-100 ${styles.filter_btn}`}
						onClick={() => setShowModals({ ...showModals, title: true })}
					>
						Job Position
					</Button>
				</Col>
				<Col className='mt-2' xs={12} sm={4}>
					<Button
						variant='outline-primary'
						className={`fw-bold w-100 ${styles.filter_btn}`}
						onClick={() => setShowModals({ ...showModals, employmentType: true })}
					>
						Full Time/Part Time
					</Button>
				</Col>
			</Row>

			<Row>
				<Col>
					{filters.mrt.length > 0 && filters.mrt.map((ele, i) => {
						if (i < 2) return <Badge pill bg='primary' key={i}>{mrtStation[ele]}</Badge>
					})}
					{filters.mrt.length > 2 && <span> ... </span>}
					{filters.city.length > 0 && filters.city.map((ele, i) => {
						if (i < 2) return <Badge pill bg='primary' key={i}>{citiesObj[Number(ele)]}</Badge>
					})}
					{filters.city.length > 2 && <span> ... </span>}
					{filters.occupation.length > 0 && filters.occupation.map((ele, i) => {
						if (i < 2) return <Badge pill bg='primary' key={i}>{occupationObject[ele]}</Badge>
					})}
					{filters.occupation.length > 2 && <span> ... </span>}
					{selectedEmploymentTypes.length > 0 &&
					selectedEmploymentTypes.map((ele, i) => {
						const returnRespectiveString = () => {
							let string
							switch (ele) {
							case 'FT':
								string = 'job_application.ft'
								break
							case 'PT':
								string = 'job_application.pt'
								break
							case 'CONTRACT':
								string = 'job_descrip.con'
								break
							case 'seniorFriendly':
								string = 'filter.senior_friendly'
								break
							case 'pwd':
								string = 'filter.pwd'
								break
							}
							return string
						}
						return <Badge key={i} pill bg='primary'>{t(returnRespectiveString())}</Badge>
					})}
					{(filters.mrt.length > 0 || filters.occupation.length > 0 || filters.jobType.length > 0) && (
						<Badge
							pill bg='danger'
							className='clickable text-white'
							style={{ cursor: 'pointer' }}
							onClick={() => { window.location.href = '/job-posters' }}
						>
							{t('clear')}</Badge>
					)}
				</Col>
			</Row>

			{posters.length === 0 && (
				<Row>
					<Col className='text-center my-5'>
						<Image src='/img/no-jobs-applied.png' alt='no-job' />
						<p><strong>{t('filter.no_jobs')}</strong></p>
						<p>
							{t('filter.try_diff_key')}
							<span style={{ color: 'orange', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { window.location.href = '/job-posters' }}>
								{t('filter.click_here')}
							</span>{t('filter.back_to_job_list')}
						</p>
					</Col>
				</Row>
			)}
			{posters.length > 0 && (
				<>
					<Row
						// data-masonry='{"percentPostion": true}'
						className='mt-4'
					>
						{posters.map((poster, index) => {
							if (poster.imageUrl !== null || poster.description !== null || poster.imageUrlChinese !== null || poster.descriptionChinese !== null) {
								return <Poster poster={poster} key={index} viewedPosters={viewedPosters} setViewedPosters={setViewedPosters} />
							}
						})}
					</Row>

					{posterAggregate.aggregate.count > 9 && (
						<Row>
							<Col>
								<div className={styles.paginationContainer}>
									<nav aria-label='Page navigation example'>
										<ul className='pagination justify-content-center pagination-md'>
											<li className={pagination.prev ? 'page-item' : 'page-item disabled'}>
												{/* <li className='page-item disabled'> */}
												<a
													className='page-link'
													href={getPaginationLink((parseInt(filters.page) - 1).toString())}
													// href='#'
													aria-disabled='true'
												>
													<FontAwesomeIcon icon={faChevronLeft} width='12px' />
												</a>
											</li>
											{pagination.pagi.map((pagi, index) => {
												return (
													<li
														key={index}
														className={pagi === 'dotted' ? 'page-item disabled' : (pagi === parseInt(filters.page) ? 'page-item active' : 'page-item')}
													>
														<a
															className='page-link'
															href={getPaginationLink(pagi.toString())}
														>
															{pagi === 'dotted' ? '...' : pagi}
														</a>
													</li>
												)
											})}
											<li
												className={pagination.next ? 'page-item' : 'page-item disabled'}
											>
												<a
													className='page-link'
													href={getPaginationLink((parseInt(filters.page) + 1).toString())}
												>
													<FontAwesomeIcon icon={faChevronRight} width='12px' />
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</Col>
						</Row>
					)}
					{viewedPosters.length > 0 && (
						<Button
							className={`position-fixed text-white fw-bold ${styles.fixedButton}`}
							onClick={() => setShowViewedPosters(true)}
						>
							<FontAwesomeIcon icon={faBasketShopping} />{' '}Job Basket
							<span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary'>
								{viewedPosters.length}
							</span>
						</Button>
					)}
				</>
			)}
			<Modal
				show={showModals.mrt}
				onHide={() => setShowModals({ ...showModals, mrt: false })}
				size='lg'
			>
				<Modal.Body>
					<Modal.Title className='text-center'>{t('filter.mrt')}</Modal.Title>

					<Form.Control
						type='text'
						placeholder='MRT station name'
						onChange={e => onChangeLocation(e.target.value)}
						value={mrtInput}
						className='my-4'
					/>
					{/* <br /> */}
					<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
						<Accordion defaultActiveKey={['0']} alwaysOpen>
							{filteredMRTLine.map((mrtLine, i) => {
								if (mrtLine.MrtStations.length > 0) {
									return (
										<Accordion.Item eventKey={i.toString()} key={i}>
											<Accordion.Header>
												<span style={{ padding: '3px 8px', borderRadius: '3px', backgroundColor: mrtLine.colour, color: 'white', fontSize: '14px' }}>
													{mrtLine.id.slice(0, -1)}
												</span>&nbsp;{mrtLine.name}
											</Accordion.Header>
											<Accordion.Body >
												<Form.Check
													type='checkbox'
													id={`select-all-${mrtLine.id}`}
													label={t('sel_all')}
													onChange={e => selectAllMRT(e)}
													value={mrtLine.id}
												/>
												{mrtLine.MrtStations.map((station, j) => {
													return (
														<Form.Check
															type='checkbox'
															id={`mrt-station-${station.id}`}
															label={station.name}
															onChange={e => selectMRT(e.target.value)}
															value={station.id}
															checked={selectedMRT.includes(station.id)}
															key={`${i}-${j}`}
														/>
													)
												})}
											</Accordion.Body>
										</Accordion.Item>
									)
								}
							})}
						</Accordion>
					</div>

					<Row className='justify-content-center mt-4'>
						<Col md={4}>
							{/* <br /> */}
							<div className='d-grid gap-2'>
								<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
								<Button variant='link' className='text-decoration-none' onClick={() => setShowModals({ ...showModals, mrt: false }) }>{t('close')}</Button>
							</div>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<Modal
				show={showModals.city}
				onHide={() => setShowModals({ ...showModals, city: false })}
				size='lg'
			>
				<Modal.Body>
					<div>
						<Modal.Title className='text-center'>City</Modal.Title>
						<br />
						<Form.Control value={cityInput} type='text' placeholder="Search by city" onChange={e => onChangeLocation(e.target.value) } />
						<br />
						<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
							<Accordion defaultActiveKey={['0']} alwaysOpen>
								{filteredState.map((ele, i) => {
									if (ele.Cities.length > 0) {
										const cityIds = ele.Cities.map((ct) => ct.id.toString())

										return (
											<Accordion.Item eventKey={i.toString()} key={i}>
												<Accordion.Header>
													{ele.name} {
														ele.Cities.length === selectedCity.filter(x => cityIds.includes(x)).length ? <Badge pill bg='success' className='mx-2'>All City selected</Badge> : selectedCity.filter(x => cityIds.includes(x)).length !== 0 ? <Badge pill bg='info' className='mx-2'>{selectedCity.filter(x => cityIds.includes(x)).length} City selected</Badge> : ''
													}
												</Accordion.Header>
												<Accordion.Body >
													<Form.Check
														type='checkbox'
														id={`select-all-${ele.id}`}
														value={ele.id}
														label={t('sel_all')}
														onChange={(e) => {
															selectAllCity(e)
														}}
														checked={selectedState.includes(ele.id.toString())}
													/>
													{ele.Cities.map((city, j) => {
														return (
															<Form.Check
																checked={selectedCity.includes(city.id.toString())}
																key={`${i}-${j}`}
																value={city.id}
																type='checkbox'
																label={city.name}
																id={`mrt-station-${city.id}`}
																onChange={(e) => {
																	selectCity(e, ele.id)
																	if(!e.target.checked) {
																		setSelectedState(selectedState.filter(function(e) { return e !== ele.id.toString() }))
																	}
																}}
															/>
														)
													})}
												</Accordion.Body>
											</Accordion.Item>
										)
									}
								})}
							</Accordion>
						</div>
						<br />
						<Row className='justify-content-center'>
							<Col md={4}>
								<br />
								<div className='d-grid gap-2'>
									<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
									<Button variant='link' className='text-decoration-none' onClick={() => { setShowModals({ ...showModals, city: false }) }}>{t('close')}</Button>
								</div>
							</Col>
						</Row>
					</div>
					<br />
				</Modal.Body>
			</Modal>

			<Modal
				show={showModals.title}
				onHide={() => setShowModals({ ...showModals, title: false })}
				size='lg'
			>
				<Modal.Body>
					<Modal.Title className='text-center mb-4'>Filter</Modal.Title>

					<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
						<Accordion defaultActiveKey={['0']} alwaysOpen>
							<Accordion.Item eventKey="0">
								<Accordion.Header>Job Position</Accordion.Header>
								<Accordion.Body>
									<Form.Check
										type='checkbox'
										id='select-all-occupation'
										label={t('sel_all')}
										onChange={selectAllTitle}
									/>
									{occupation.map((ele, i) => {
										return (
											<Form.Check
												type='checkbox'
												id={`occup-${ele.id}`}
												label={ele.name}
												onChange={e => selectTitle(e.target.value)}
												value={ele.id}
												checked={selectedTitles.includes(ele.id)}
												key={`occup-${i}`}
											/>
										)
									})}
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</div>

					<Row className='justify-content-center mt-4'>
						<Col md={4}>
							{/* <br /> */}
							<div className='d-grid gap-2'>
								<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
								<Button variant='link' className='text-decoration-none' onClick={() => setShowModals({ ...showModals, title: false }) }>{t('close')}</Button>
							</div>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<Modal
				show={showModals.employmentType}
				onHide={() => setShowModals({ ...showModals, employmentType: false })}
				size='lg'
			>
				<Modal.Body>
					<Modal.Title className='text-center mb-4'>Filter</Modal.Title>

					<div style={{ maxHeight: '60vh', overflow: 'auto' }}>
						<Accordion defaultActiveKey={['0']} alwaysOpen>
							<Accordion.Item eventKey="0">
								<Accordion.Header>Employment Type</Accordion.Header>
								<Accordion.Body>
									<Form.Check
										type='checkbox'
										id='job-type-full-time'
										label={t('job_descrip.ft')}
										onChange={() => { selectEmploymentType('FT') }}
										value='FT'
										checked={selectedEmploymentTypes.includes('FT')}
										key='job-type-full-time'
									/>
									<Form.Check
										type='checkbox'
										id='job-type-part-time'
										label={t('job_descrip.pt')}
										onChange={() => { selectEmploymentType('PT') }}
										checked={selectedEmploymentTypes.includes('PT')}
										value='PT'
										key='job-type-part-time'
									/>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</div>

					<Row className='justify-content-center mt-4'>
						<Col md={4}>
							{/* <br /> */}
							<div className='d-grid gap-2'>
								<Button variant='primary' className='text-white' onClick={submitFilter}>{t('search')}</Button>
								<Button variant='link' className='text-decoration-none' onClick={() => setShowModals({ ...showModals, employmentType: false }) }>{t('close')}</Button>
							</div>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<ViewedPosters
				showViewedPosters={showViewedPosters} setShowViewedPosters={setShowViewedPosters}
				viewedPosters={viewedPosters} setViewedPosters={setViewedPosters}
			/>
		</>
	)
}

export async function getServerSideProps({ locale, query })  {
	const client = createClient({
		endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
		// headers: { 'X-Hasura-Admin-Secret': process.env.HASURA_ADMIN_SECRET as string }
	})

	const mrt = typeof query.mrt !== 'undefined' ? query.mrt.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '') as string : ''
	const occupation = typeof query.occupation !== 'undefined' ? query.occupation.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '') as string : ''
	const jobType = typeof query.jobType !== 'undefined' ? query.jobType.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '') as string : ''
	const city = typeof query.city !== 'undefined' ? query.city.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\{\}\[\]\\\/]/gi, '') as string : ''
	const filters = {
		page: typeof query.page !== 'undefined' && parseInt(query.page) ? Number(query.page) : 1,
		mrt: mrt.split(',').filter(ele => ele !== ''),
		occupation: occupation.split(',').filter(ele => ele !== ''),
		jobType: jobType.split(',').filter(ele => ele !== ''),
		city: city.split(',').filter(ele => ele !== '')
	}
	const { page: currentPage } = filters

	try {
		const hasuraQuery = await client.query({
			query: `
				query ($offset: Int! $mrt: [String!] $occupation: [Int!] $city: [Int!]) {
					JobPoster_Job(
						limit: 9
						offset: $offset
						order_by: {jobPostStart: desc}
						where: {
							country: {_eq: "${locale.toLocaleUpperCase()}"}
							jobPostStart: {_lte: "now()"}
              jobPostEnd: {_gt: "now()"}
              isAvailable: {_eq: true}
							${filters.mrt.length > 0 ? `
							_or: [
								{nearestMrt: {_in: $mrt}}
								{nearestMrt: {_is_null: true}}
							]
							` : ''}
							${filters.city.length > 0 ? `
							_or: [
								{locationCity: {_in: $city}}
								{locationCity: {_is_null: true}}
							]
							` : ''}
							occupation: {_in: $occupation}
							${filters.jobType.length === 1 ? `employmentType: {_in: ["BOTH", "${filters.jobType[0]}"]}` : ''}
						}
					) {
						id
						description descriptionChinese
						imageUrl imageUrlChinese
						contact
						MrtStation {
							id name
							MrtLine { colour}
						}
						Company { name avatar}
					}

					JobPoster_Job_aggregate(
						where: {
							country: {_eq: "${locale.toLocaleUpperCase()}"}
							jobPostStart: {_lte: "now()"}
              jobPostEnd: {_gt: "now()"}
              isAvailable: {_eq: true}
							${filters.mrt.length > 0 ? `
							_or: [
								{nearestMrt: {_in: $mrt}}
								{nearestMrt: {_is_null: true}}
							]
							` : ''}
							${filters.city.length > 0 ? `
							_or: [
								{locationCity: {_in: $city}}
								{locationCity: {_is_null: true}}
							]
							` : ''}
							occupation: {_in: $occupation}
							${filters.jobType.length === 1 ? `employmentType: {_in: ["BOTH", "${filters.jobType[0]}"]}` : ''}
						}
					) {
						aggregate { count}
					}

					MrtLine(where: {
						# Exclude LRT
						id: {_nin: ["BPL", "PEL", "PWL", "SEL", "SWL"]}
					}) {
						id name colour
						MrtStations {
							id name
						}
					}
					# Render which stations are selected...
					MrtStation(where: {
						MrtLine: {id: {_nin: ["BPL", "PEL", "PWL", "SEL", "SWL"]}}
					}) {
						id name
					}

					State {
						id
						name
						country
						Cities {
							id
							name
						}
					}
					City {
						id
						name
					}

					Occupation(order_by: {name: asc}) {
						id
						name
					}
				}
			`,
			variables: {
				offset: (currentPage - 1) * 9,
				mrt: filters.mrt.length > 0 ? filters.mrt : null,
				occupation: filters.occupation.length > 0 ? filters.occupation : null,
				city: filters.city.length > 0 ? filters.city : null
				// employmentType: filters.jobType.length > 0 ? filters.jobType : null
			}
		})

		const hasuraRes = await hasuraQuery

		const { data: { JobPoster_Job: posters, JobPoster_Job_aggregate: posterAggregate, MrtLine: mrtLine, MrtStation, Occupation: occupation, State, City }} = hasuraRes
		interface Pagination {
			prev: boolean,
			pagi: (number|string)[],
			next: boolean
		}

		const numOfPage = Math.ceil(posterAggregate.aggregate.count / 9)
		const pagination: Pagination = {
			prev: false,
			pagi: [],
			next: false
		}

		if (numOfPage < 6) {
			pagination.pagi = Array.from(Array(numOfPage), (e, i) => i + 1)
		} else {
			if (currentPage < 3) {
				pagination.pagi = Array.from(Array(3), (e, i) => i + 1)
				pagination.pagi.push('dotted')
				pagination.pagi.push(numOfPage)
			} else {
				const tempPagiItems: (number|string)[] = []

				if (currentPage - 1 > 1) {
					if (currentPage - 2 !== 1) {
						tempPagiItems.push(1)
						if (currentPage - 2 !== 1) {
							tempPagiItems.push('dotted')
						}
					}
				}

				if (currentPage - 1 > 1) {
					if (currentPage - 2 === 1) tempPagiItems.push(currentPage - 2)
					tempPagiItems.push(currentPage - 1)
				}

				tempPagiItems.push(currentPage)
				if (currentPage + 1 <= numOfPage) {
					tempPagiItems.push(currentPage + 1)
					if (currentPage + 2 === numOfPage) tempPagiItems.push(currentPage + 2)
				}
				if (currentPage + 2 <= numOfPage) {
					if (currentPage + 2 !== numOfPage) {
						if (currentPage + 3 <= numOfPage) {
							tempPagiItems.push('dotted')
						}
						tempPagiItems.push(numOfPage)
					}
				}

				pagination.pagi = tempPagiItems
			}
		}

		if (currentPage > 1) pagination.prev = true
		if (currentPage < numOfPage) pagination.next = true

		const mrtStation = {}
		MrtStation.forEach(station => {
			mrtStation[station.id] = station.name
		})
		const occupationObject = {}
		occupation.forEach(ele => {
			occupationObject[ele.id] = ele.name
		})
		const citiesObj = {}
		City.forEach(ele => citiesObj[ele.id] = ele.name)

		// if (posters.length > 0) {
		return { props: {
			...(await serverSideTranslations(locale, ['common'])),
			posters,
			pagination,
			posterAggregate,
			filters,
			mrtLine,
			mrtStation,
			state: State,
			citiesObj,
			occupation,
			occupationObject
		}}
		// } else return { notFound: true }
	} catch (err) {
		console.error(err)

		return { notFound: true}
	}
}

export default JobPosters
